import { useEffect } from 'react';

const BASE_TITLE = 'DocuMint Admin';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = `${title} | ${BASE_TITLE}`;

    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
};
